<template>
  <div>
    <svg class="nice" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <circle
        class="path circle"
        :class="playState ? 'animate' : ''"
        :fill="fill"
        :stroke="color"
        stroke-width="6"
        stroke-miterlimit="10"
        cx="65.1"
        cy="65.1"
        r="62.1"
      />
      <polyline
        class="path check"
        :class="playState ? 'animate' : ''"
        fill="none"
        :stroke="color"
        stroke-width="6"
        stroke-linecap="round"
        stroke-miterlimit="10"
        points="100.2,40.2 51.5,88.8 29.8,67.5 "
      />
    </svg>
    <h2 :style="'color:' + color" class="text-center">
      {{ title }}
    </h2>
    <h5 :class="'text-center ' + textClass">
      {{ subtext }}
    </h5>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    title: { type: String, required: false },
    subtext: { type: String, required: false },
    color: { type: String, required: false, default: "#73AF55" },
    fill: { type: String, required: false, default: "none" },
    textClass: { type: String, required: false, default: "text-muted" },
    playState: { type: Boolean, default: true },
  },

  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
svg {
  margin: 0 auto;
  width: 132px;
  display: block;
}
.path.animate {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle.animate {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line.animate {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check.animate {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
</style>
